import { TemplateType } from '../../../../models/Templates';

export const templatesDisplayOrder = [
  TemplateType.CUSTOM_TEMPLATE,
  TemplateType.SYSTEM_TEMPLATE,
  TemplateType.SYSTEM_AUTOMATIC_TEMPLATE,
];
